export default __webpack_public_path__ + "static/every_interaction-edf806ef61b2706e378d6467962a9374.svg";